<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/scheme/03/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>{{z_g_l_l_h_j_s_form.title_1}}</span>
                                <span>{{z_g_l_l_h_j_s_form.title_2}}</span>
                            </div>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_1}}</p>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_2}}</p>
                            <p class="text">{{z_g_l_l_h_j_s_form.content_3}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="s-q-y-l-g-l page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="s-q-y-l-g-l-content">
                            <div class="title">
                                <span>居家养老</span>
                                <span>为什么这么难?</span>
                            </div>
                            <auto-row class="max-size list flew-row-wrap">
                                <auto-col class="list-item" v-for="(item,index) of s_q_y_l_g_l_list" :key="index">
                                    <div class="cell">
                                        <div class="title">{{item.title}}</div>
                                        <div class="line"></div>
                                        <p class="text">{{item.content}}</p>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-m-d-y-s page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="w-m-d-y-s-content">
                            <div class="title">
                                <span>我们的</span>
                                <span>优势?</span>
                            </div>
                            <auto-row class="max-size list flew-row-wrap">
                                <auto-col class="list-item" v-for="(item,index) of w_m_d_y_s_list" :key="index">
                                    <div class="cell">
                                        <img :src="item.icon" height="48" alt="">
                                        <div class="title">{{item.title}}</div>
                                        <p class="text">{{item.content}}</p>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-child"
                 v-for="(src,i) of imgArr"
                 :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>运营数据</span>
                                <span>可视化管理</span>
                            </div>
                            <p class="text">服务对象类型统计、能力评估统计、服务动态统计、预警统计、适老化设备统计等数据可视化展示。</p>
                            <img src="@/assets/image/scheme/02/pic-07.png" style="margin-top:60px;" width="85%" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    // require('@/assets/image/scheme/03/pic-01.png'),
                    // require('@/assets/image/scheme/03/pic-02.png'),
                    // require('@/assets/image/scheme/03/pic-03.png'),
                    require('@/assets/image/scheme/03/pic-04.png'),
                    // require('@/assets/image/scheme/03/pic-05.png'),
                ],
                z_g_l_l_h_j_s_form:{ //中国老龄化加深
                    title_1:'中国老龄化',
                    title_2:'加深',
                    content_1:'据国家统计局数据，截至2019年年末，全国60周岁及以上人口为25388万人，占18.1%。其中，65岁及以上人口为17603万人，占12.6%。随着老年人口的不断增多，各地开始对养老福利模式进行积极的探索，居家养老服务应运而生。',
                    content_2:'居家养老（服务），是指以家庭为核心、以社区为依托、以专业化服务为依靠，为居住在家的老年人提供以解决日常生活困难为主要内容的社会化服务。',
                    content_3:'服务内容包括生活照料与医疗服务以及精神关爱服务。主要形式有两种：由经过专业培训的服务人员上门为老年人开展照料服务；在社区创办老年人日间服务中心，为老年人提供日托服务，服务一般是三无老人。'
                },
                s_q_y_l_g_l_list:[
                    {title:'居家服务如何盈利',content:'运营决策缺乏数据支撑，投入与需求匹配不当导致成本浪费。'},
                    {title:'服务质量如何监管',content:'服务人员的工单质量难以衡量，弄虚作假又该如何避免。'},
                    {title:'突发事件如何预防',content:'如何实现对老人进行24小时监护、意外事故的预警和及时处理。'},
                    {title:'服务流程如何规范',content:'服务流程混乱不统一，如何进行规范化管理及监督。'},
                    {title:'老人子女如何安心',content:'老人在家的生活、护理以及突发情况，如何实时让子女知晓。'},
                    {title:'政府采购如何满足',content:'政府采购项目中，需要满足哪些条件，实施方式，又该如何向相关部门展示。'}
                ],

                w_m_d_y_s_list:[
                    {title:'运营数据可视化',icon:require('@/assets/image/scheme/03/4-1.png'),content:'老人信息、护理服务、费用账单、安全报警等数据，能实现可视化监控及分析，为业务管理提供数据支撑。'},
                    {title:'7*24小时数据监控服务',icon:require('@/assets/image/scheme/03/24h.png'),content:'客服团队7*24小时全年无休的数据监控服务，响应并处理报警信息，突发情况紧急救助，为政府关注的老人、残疾人等弱势群体形成救援网络。'},

                    {title:'管理流程规范智能',icon:require('@/assets/image/scheme/03/4-5.png'),content:'业务流程能够自动流转，数据管理实现智能化，提升养老服务中心运营管理效率。'},
                    {title:'移动端随时查看',icon:require('@/assets/image/scheme/03/4-2.png'),content:'老人健康数据随时掌控，护理记录随时查询、费用账单随时查看、安全报警实时通知、视频监控随时调取。'},

                    {title:'服务质量监管',icon:require('@/assets/image/scheme/03/4-4.png'),content:'对服务人员GPS定位，服务现场照片上传，服务过程全程录音，老人进行服务评价，机构针对工单进行满意度回访。'},
                    {title:'丰富的成熟案例',icon:require('@/assets/image/scheme/03/4-3.png'),content:'全国多地的市、区县成熟建设案例，并与各地多家民政机构达成战略合作，提供可持续的智慧养老相关服务。'}
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(2n+1){
        background-color:#ffffff;
    }
    .page-content-child:nth-child(2n+2){
        background-color: #F9F9F9;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }


    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:150px 0 200px 0;
    }


    .f-a-j-j .text{
        color:#333333;
        font-size: 24px;
        padding:30px 140px 0 140px;
        line-height: 1.6;
        text-align: left;
        transition: all .3s;
    }

    .f-a-j-j .text:nth-of-type(1){
        padding-top:60px;
    }

    .f-a-j-j .text:hover{
        transform: translateY(-5px);
    }

    .s-q-y-l-g-l .s-q-y-l-g-l-content{
        text-align: center;
        padding:128px 0 200px 0;
    }


    .s-q-y-l-g-l .list{
        width:calc(100% + 40px);
        text-align: center;
        margin-left: -20px;
        padding:0 10px;
    }

    .s-q-y-l-g-l .list-item{
        width:calc(33.33% - 40px);
        margin: 0 20px;
        margin-top:80px;
        text-align: center;
        transition: all .3s;
        height: 20vw;
        max-height: 200px;
        box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
    }

    .s-q-y-l-g-l .list-item .cell{
        padding:30px 20px 0 20px;
        text-align: left;
    }

    .s-q-y-l-g-l .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        margin-bottom:5px;
    }

    .s-q-y-l-g-l .list-item .cell .line{
        width:100px;
        height: 3px;
        background: #2FA8D0;
    }

    .s-q-y-l-g-l .list-item .cell .text{
        line-height: 1.6;
        padding-top:20px;
        font-size: 18px;
        color:#333333;
    }

    .s-q-y-l-g-l .list-item:hover{
        transform: translateY(-5px);
        box-shadow: 0px 8px 11px 0px rgba(65,61,61,0.23);
    }



    .w-m-d-y-s .w-m-d-y-s-content{
        text-align: center;
        padding:100px 0 150px 0;
        margin:0 60px;
    }

    .w-m-d-y-s .list{
        width:calc(100% + 100px);
        text-align: left;
        margin-left: -50px;
    }

    .w-m-d-y-s .list-item{
        width:calc(50% - 100px);
        margin: 0 50px;
        margin-top:120px;
        text-align: left;
        transition: all .3s;
    }

    .w-m-d-y-s .list-item:hover{
        transform: translateY(-5px);
    }

    .w-m-d-y-s .list-item .cell{
        text-align: left;
    }

    .w-m-d-y-s .list-item .cell .title{
        font-size: 24px;
        color: #333333;
        padding-top:15px;
    }

    .w-m-d-y-s .list-item .cell .text{
        line-height: 1.6;
        padding-top:15px;
        font-size: 18px;
    }


    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:130px 0 180px 0;
        }

        .f-a-j-j .text{
            padding:30px 100px 0 100px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:100px 0 160px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:70px;
            text-align: center;
            transition: all .3s;
            height: 20vw;
            max-height: 200px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:80px 0 130px 0;
        }

    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 160px 0;
        }

        .f-a-j-j .text{
            padding:30px 60px 0 60px;
        }


        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:80px 0 120px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:60px;
            text-align: center;
            transition: all .3s;
            height: 30vw;
            max-height: 200px;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:60px 0 110px 0;
        }
    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:90px 0 140px 0;
        }

        .f-a-j-j .text{
            padding:30px 10px 0 10px;
        }

        .s-q-y-l-g-l .s-q-y-l-g-l-content{
            text-align: center;
            padding:60px 0 80px 0;
        }

        .s-q-y-l-g-l .list-item{
            width:calc(50% - 40px);
            margin: 0 20px;
            margin-top:50px;
            text-align: center;
            transition: all .3s;
            max-height: auto!important;
            box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.1);
        }

        .w-m-d-y-s .w-m-d-y-s-content{
            padding:40px 0 90px 0;
        }
    }
</style>
